module.exports = __webpack_public_path__ + "img/一汽光洋.png";